import { ForgeUser } from '../ForgeUser';

export class FrontendForgeUser extends ForgeUser
{
    public async getAccessibleHubs()
    {
        return [];
    }

    public static fromJSON(json: any)
    {
        const user = new FrontendForgeUser();
        user.email = json.email;
        user.forgeID = json.forgeID;
        user.name = json.name;
        user.roleIds = json.roleIds;
        return user;
    }
}
